import { render, staticRenderFns } from "./completed-course-old.vue?vue&type=template&id=4cf31dfa&"
import script from "./completed-course-old.js?vue&type=script&lang=js&"
export * from "./completed-course-old.js?vue&type=script&lang=js&"
import style0 from "./completed-course-old.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports